"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * @deprecated
 * This is a replacer of 'react-clamp-lines' library
 * the reason of the replacement is a migration to Preact X
 * It's worth to create a proper ClampLines component
 */
var ClampLines = function ClampLines(_ref) {
  var id = _ref.id,
      text = _ref.text,
      className = _ref.className,
      lines = _ref.lines,
      _ref$innerElement = _ref.innerElement,
      InnerElement = _ref$innerElement === void 0 ? 'div' : _ref$innerElement;
  return (0, _preact.h)("span", {
    className: (0, _classnames.default)('clamp-lines', className),
    style: {
      wordBreak: 'break-word',
      display: 'block'
    }
  }, (0, _preact.h)(InnerElement, {
    id: "clamped-content-".concat(id),
    style: {
      display: '-webkit-box',
      WebkitLineClamp: lines,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    }
  }, text));
};

var _default = ClampLines;
exports.default = _default;